import { ExaminationSessionList } from './../../model/examination-session.model';
import { createReducer, on } from '@ngrx/store';
import { Action } from '@ngrx/store';
import * as ExaminationSessionActions from '../actions/examination-session.actions';

export interface ExaminationSessionsData {
    ExaminationSessions: ExaminationSessionList | null,
    loading: boolean
}

export const initialState: ExaminationSessionsData = {
    ExaminationSessions: null,
    loading: false,
};

const examinationSessionReducer = createReducer(
    initialState,
    on(ExaminationSessionActions.GetExaminationSession, (state) => ({ ...state, loading: true })),
    on(ExaminationSessionActions.GetExaminationSessionSuccess, (state, action) => ({ ...state, ExaminationSessions: action.payload, loading: false })),
    on(ExaminationSessionActions.GetExaminationSessionFailure, (state) => ({ ...state, ExaminationSessions: null, loading: false })),
);

export function reducer(state: ExaminationSessionsData | undefined, action: Action) {
    return examinationSessionReducer(state, action);
}